var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
export var useInterval = function (callback, delay, dependencyList) {
    if (dependencyList === void 0) { dependencyList = []; }
    var intervalId = React.useRef(null);
    // Set up the interval.
    React.useEffect(function () {
        intervalId.current = setInterval(callback, delay);
        return function () { return clearInterval(intervalId.current); };
    }, __spreadArray([delay, callback], dependencyList, true));
    return function () { return clearInterval(intervalId.current); };
};
